import type React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'

const PrivateRoute = (): React.JSX.Element => {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) return <></>

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />
}

export default PrivateRoute
